import Xhr from '@Core/xhr'
import cloneDeep from 'lodash/cloneDeep'

export default {

  async requestShippingData ({ state, commit }) {
    if (! state.data) {
      commit('setLoading', { loading: true })
      let shippingData = await new Xhr().get(`shipping/data`)
      commit('setLoading', { loading: false })
      commit('setData', { shippingData })
    }
  },

  setShippingOption ({ commit, dispatch }, value) {
    commit('option', value)

    //- Refetch gateway form if total price changed
    // setTimeout(() => {
    //   dispatch('cart/payment/getCheckoutForm', null, { root: true })
    // }, 1000)
  },

  setShippingLocationId ({ commit }, value) {
    commit('locationId', value)
  },

  setUseAltShipping ({ commit }, value) {
    commit('useAlt', value)
  },

  setAltShipping ({ commit }, { altShipping }) {
    commit('altShipping', cloneDeep(altShipping))
  }

}
